document.addEventListener("DOMContentLoaded", (event) => {
    console.log('running custom js');


    /* visibility helper - delegated so listeners survive cart re-renders */
    document.addEventListener("click", (e) => {
        const $trigger = e.target.closest(".toggle-visibility__trigger");
        if (!$trigger) return;

        const group = $trigger.dataset.visibilityGroup;
        const $targets = document.querySelectorAll(`.toggle-visibility__target[data-visibility-group="${group}"]`);
        const $triggers = document.querySelectorAll(`.toggle-visibility__trigger[data-visibility-group="${group}"]`);

        $targets.forEach($target => {
            $target.classList.toggle('active', $target.dataset.visibilityId == $trigger.dataset.visibilityTarget);
        });

        $triggers.forEach($t => {
            $t.classList.toggle('active', $t === $trigger);
        });
    });
});